import { render } from "./sysDictionary.vue?vue&type=template&id=36559bd1&scoped=true"
import script from "./sysDictionary.vue?vue&type=script&lang=js"
export * from "./sysDictionary.vue?vue&type=script&lang=js"

import "./sysDictionary.vue?vue&type=style&index=0&id=36559bd1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36559bd1"]])

export default __exports__